<template>
  <div>
    <form id="add-collection"
          @submit.prevent="save(form)"
          @keydown="clearFormValidationError"
          @change="clearFormValidationError">
      <div class="set-after">
        <label>Illustration (700x250px minimum)</label>
        <div class="image-input">
          <div class="image-cell" v-if="!form.public_path"></div>
          <img v-else :src="form.cropPublicPath ? form.cropPublicPath : form.public_path"
               style="width: 100px; height: 100px" data-rjs="2">
          <button type="button" id="dropInput" :disabled="imageUploading"
                  :action="image ? imageApi.replace_image_set_image_url : imageApi.upload_image_url">
            <i class="fa fa-spinner fa-spin" v-if="imageUploading"></i> Upload Image
          </button>
          <strong class=""></strong>

          <validation-message :errors="form.errors" property-name="cover_image_id"></validation-message>
        </div>
      </div>
      <div class="set-after">
        <label for="title">Title</label>
        <input type="text" id="title" class="long-input" name="title" v-model="form.title">
        <validation-message :errors="form.errors" property-name="title"></validation-message>
      </div>
      <div class="set-after">
        <label>Description (not required)</label>
        <ck-editor name="description" @change="clearFormValidationError" v-model="form.description"></ck-editor>

        <validation-message :errors="form.errors" property-name="description"></validation-message>
      </div>
      <spinner v-if="loading"></spinner>
      <div v-else>
        <div class="set-after">
          <label class="checkbox-common-label">Subject (max - 2)</label>
          <label class="checkbox-label" v-for="artSubject in artSubjects">
            <input type="checkbox" name="subjects[]" :value="artSubject.id" v-model="form.art_subjects">{{ artSubject.name
            }}
          </label>
        </div>
        <div class="set-after">
          <label class="checkbox-common-label">Styles (max - 2)</label>
          <label class="checkbox-label" v-for="style in styles">
            <input type="checkbox" name="styles[]" :value="style.id" v-model="form.styles">{{ style.name}}
          </label>
        </div>
      </div>
      <div class="set-after">
        <label for="keywords">Keywords (separate each word with a comma)</label>
        <input type="text" name="keywords" id="keywords" v-model="form.keywords" class="long-input">

        <validation-message :errors="form.errors" property-name="keywords"></validation-message>
      </div>
      <div class="bootstrap-row">
        <div class="col-six">
          <label class="add-bottom">
            <input type="checkbox"
                   name="show_error"
                   v-model="form.show_in_portfolio"
                   @change="clearFormValidationError">
            <span class="label-text">Include in main portfolio</span>
          </label>

          <validation-message :errors="form.errors" property-name="show_error"></validation-message>
        </div>
        <spinner v-if="!user"></spinner>
        <div class="col-six" v-else>
          <div v-if="user.has_published_book_access">
            <label class="add-bottom">
              <input type="checkbox"
                     name="show_error"
                     v-model="form.show_in_published_books"
                     @change="clearFormValidationError">
              <span class="label-text">Include in published books</span>
            </label>

            <validation-message :errors="form.errors" property-name="show_error"></validation-message>
          </div>
          <div class="alert alert-info" v-else>
            <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
            <p>Increase exposure for this work by purchasing the Published Book upgrade.</p>
          </div>
        </div>
      </div>

      <div class="image-set__include-pb"
           v-if="user && user.has_published_book_access && form.show_in_published_books">
        <div class="set-after">
          <label for="publisher">Publisher</label>
          <input type="text" id="publisher" class="long-input" name="book.publisher" v-model="form.book.publisher">

          <validation-message :errors="form.errors" property-name="book.publisher"></validation-message>
        </div>
        <div class="set-after">
          <label for="title">Author</label>
          <input type="text" id="author" class="long-input" name="book.author" v-model="form.book.author">

          <validation-message :errors="form.errors" property-name="book.author"></validation-message>
        </div>
        <spinner v-if="categories === null"></spinner>
        <div class="set-after" v-else>
          <label for="category">Category</label>
          <div class="select-wrapper">
            <select name="book.category_id" id="category" class="long-input" v-model="form.book.category_id">
              <option :value="category.id" v-for="category in categories">{{category.name}}</option>
            </select>

            <validation-message :errors="form.errors" property-name="book.category_id"></validation-message>
          </div>
        </div>
      </div>

      <button type="submit" class="big-purple-button" v-if="!imageUploading">{{ image ? 'Update' : 'Add'}}</button>
    </form>
  </div>
</template>

<script>
  import artSubjectApi from './../../../../api/art-subject';
  import searchTermApi from './../../../../api/search-term';
  import imageApi from './../../../../api/image';
  import bookCategoryApi from './../../../../api/published-book/category';
  import userApi from './../../../../api/user';
  import Form from './../../../../Form';
  import * as constants from './../constants';

  export default {
    props: {
      save: {
        type: Function,
        required: true,
      },
      image: {
        type: [Object, null],
        default() {
          return null;
        },
      },
    },
    data() {
      return {
        cropper: {
          show: false,
          imgSrc: '',
        },
        artSubjects: null,
        styles: null,
        user: null,
        categories: null,
        form: new Form({
          title: null,
          description: null,
          keywords: null,
          show_in_portfolio: true,
          show_in_published_books: false,

          book: {
            publisher: null,
            author: null,
            category_id: null,
          },

          image_id: '',
          public_path: null,
          cropPublicPath: null,

          art_subjects: [],
          styles: [],

          ...this.image,
        }),
        imageUploading: false,
        imageApi,
      }
    },
    mounted() {
      this.fetchData();

      if (this.image) {
        this.prepareForm();
      }

      this.setupDropzone();
    },
    methods: {
      prepareForm() {
        this.form.art_subjects = this.image.art_subjects.map(subject => subject.id);
        this.form.styles = this.image.styles.map(style => style.id);

        if (this.image.book) {
          this.form.book = this.image.book;
        } else {
          this.form.book = {
            publisher: null,
            author: null,
            category_id: null,
          };
        }

        this.form.image_id = this.image.image.id;
        this.form.public_path = this.form.cropPublicPath = this.image.imagePath;
      },
      setupDropzone() {
        let self = this;

        Dropzone.options.dropInput = {
          paramName: 'image',
          createImageThumbnails: false,
          dictDefaultMessage: '',
          timeout: configs.dropzoneTimeout,
          params: {
            file_id: self.image ? self.image.image.id : null,
            image_set_image_id: self.image ? self.image.id : null,
            create_auto_crop: true,
          },
          addedfile: function () {
            self.imageUploading = true;
          },
          error: function (f, data) {
            this.removeFile(f);

            self.imageUploading = false;

            let firstErrorKey = Object.keys(data.errors)[0],
              firstError = data.errors[firstErrorKey][0];    //Get first error

            toastr.error(firstError);
          },
          success: function (f, image) {
            this.removeFile(f);

            self.form.image_id = image.id;
            self.form.public_path = image.public_path;

            self.form.cropPublicPath = image.imagePath;

            self.cropper.imgSrc = image.public_path;

            //If crop image wasn't created automatically (image height >= 400px)
            if (!self.form.cropPublicPath) {
            self.cropper.show = true;
            }

            self.imageUploading = false;
          }
        };

        $("#dropInput").dropzone({
          maxFiles: 1,
        });
      },
      fetchData() {
        artSubjectApi.all().then((artSubjects) => {
          this.artSubjects = artSubjects;
        });

        userApi.fetchUser().then((user) => {
          this.user = user;
        });

        searchTermApi.all().then((searchTerms) => {
          this.prepareStyles(searchTerms);
        });
        bookCategoryApi.all().then((categories) => {
          this.categories = categories;
        });
      },
      clearFormValidationError(event) {
        if (event.target.name) {
          this.form.errors.clear(event.target.name);
        }
      },
      prepareStyles(searchTerms) {
        this.styles = searchTerms.filter((searchTerm) => searchTerm.dictionary_id == constants.STYLES_DICTIONARY_ID);
      },
    },
    computed: {
      loading() {
        return !this.artSubjects || !this.styles;
      },
    },
    watch: {
      'form.art_subjects': function (value) {
        if (value.length <= 2) return;

        value.pop();

        toastr.error('Limit of subjects for image is 2');
      },
      'form.styles': function (value) {
        if (value.length <= 2) return;

        value.pop();

        toastr.error('Limit of styles for image is 2');
      },
    },
  }
</script>